import React from "react";
import '../css/styles.css'

export default function VerticalLine(props) {
    return <div className={"border-l-2 " + props.height} style={{color: props.color || '#7C7C7C'}} />
}